import { render } from "./CenterSpinner.vue?vue&type=template&id=534aff6f"
import script from "./CenterSpinner.vue?vue&type=script&lang=js"
export * from "./CenterSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__